import { SubtaskCorrespondenceEmailModel } from "../vetting/vetting.models";
import { BaseValidationResponse } from "../validations/validations.models";
import { IEntityTypeIdentifier } from "@rightship-tech/common-ui/models/basic.models";

export interface NewFbrResponse extends BaseValidationResponse {
    fbrId: number;
    questions: NewFbrQuestionResult[];
}

export interface NewFbrQuestionResult {
    fbrItemQuestionId: number;
    fbrItemId?: number;
}

export interface NewFbrQuestionRequest {
    fbrItemId?: number;
    fbrItemQuestionId: number;
    fbrItemAnswerId: number;
    rightShipToReview: boolean;
    comments: string;
}

export interface NewFbrRequest {
    fbrId: number;
    vesselId: number;
    onBehalfOfBusinessUnitId: number;
    fbrQuestioner: number;
    questions: NewFbrQuestionRequest[];
    portId: number;
    meta: string;
    terminal: string;
    berth: string;
    comments: string;
    loading: boolean;
    discharge: boolean;
    sts: boolean;
    other: boolean;
    dateReported: Date;
    vesselPortCallId?: number;
}

export enum FbrStatusEnum {
    New = 1,
    InProgress = 2,
    AwaitingResponse = 3,
    PendingReview = 4,
    Closed = 5,
    FbrReassignment = 6,
    Expired = 7,
    Cancelled = 8,
    PendingTerminalReview = 9
}

export interface FbrStatusHistoryClientModel {
    createdDate: Date;
    status: string;
    previousStatusId?: number;
    statusId: number;
    user: string;
    comment: string;
    fullComment: string;
    subtaskTypes: number[];
}

export interface LinkedPscInspectionModel {
    pscInspectionId: number;
    inspectionDate: Date;
    port: string;
    pscAuthority: string;
}

export interface LinkedIncidentModel {
    incidentId: number;
    incidentDate: Date;
    casualtyType: string;
    severity: string;
}

export interface FbrItemClientModel {
    linkedIncidents: LinkedIncidentModel[];
    comment: string;
    commentDateModified: Date;
    lastModifiedDate?: Date;
    fbrItemId: number;
    question: string;
    answer: string;
    cfrId?: number;
    description: string;
    outcome: number;
    title: string;
    subtaskTypes: number[];
    sequenceNumber?: number;
    cfrStatusId?: number;
    cfrStatus?: string;

    rightShipReviewRequired: boolean;

    flagForCustomer: boolean;
    flagForAllVets: boolean;
    element?: HTMLElement;
    hasComments: boolean;
    hasAttachments: boolean;
}

export interface GetVesselFbrPerformanceResponse {
    items: VesselFbrPerformanceItem[];
}

export interface VesselFbrPerformanceItem {
    date: string;
    subCategory: string;
    category: string;
    outcome: number;
    fbrId: number;
    fbrQuestionerType: number;
}

export interface FbrClientModel extends IEntityTypeIdentifier {
    fbrId: number;
    cargoTypeCategoryId: number;
    metaData: any;
    vesselId: number;
    fbrStatusId: number;
    fbrStatus: string;
    yearOfConstruction?: number;
    dateRequested: Date;
    built?: Date;
    deadWeightTonnage: number;
    requestedBy: string;
    phoneNumbers: string[];
    port: string;
    terminal: string;
    berth: string;
    assignedUserId: number;
    assignedTo?: string;
    internationalMaritimeOrganizationNumber: string;
    vehicleIdentificationNumber: string;
    europeanNumberOfIdentification: string;
    vesselName: string;
    vesselType: string;
    comments: string;
    fbrQuestionnaireTypeText: string;
    fbrQuestionnaireType?: number;
    fbrItems: FbrItemClientModel[];
    fbrStatusHistory: FbrStatusHistoryClientModel[];
    fbrCorrespondenceEmails?: SubtaskCorrespondenceEmailModel[];
    portId?: number;
    requestedByBusinessUnitId?: number;
    requestedByBusinessUnit?: string;
    requestedByCustomerId?: number;
    requestedOnBehalfOfBusinessUnitId?: number;
    requestedOnBehalfOfCustomerId?: number;
    portCountry?: string;
    requestedByUserId?: number;
    requestedByEmail?: string;
    isLoading?: boolean;
    isSTS?: boolean;
    isDischarge?: boolean;
    isOther?: boolean;
    starRating: number;
    rating: string;
    documentsCount?: number;
    privateNotesCount?: number;
    correspondenceCount?: number;
    alertEmails?: SubtaskCorrespondenceEmailModel[];
}

export enum FbrItemGroupingEnum {
    UnsatisfactoryRequiresReview = 1,
    UnsatisfactoryNoReviewRequired = 2,
    Satisfactory = 3,
    NotObserved = 4
}

export enum FbrItemOutcomeStepEnum {
    Pass = 1,
    Fail = 2,
    NA = 3
}

export enum FbrQuestionnaireTypesEnum {
    TankerTerminalReport = 1,
    DryBerthReport = 2,
    LoadingReport = 3
}
